.thread {
  list-style: none;
  margin: 0;
  padding: 0;
}
